<nav #navbar class="navbar active">
    <div class="container-fluid p-0">
      <!-- <div class="navbar-header" id="navbar-header" >
        <a href="javascript:void(0)" onClick="return false;" class="navbar-toggle collapsed"
          (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a> -->
        <!-- <a class="navbar-brand" href="https://www.thinq24.com" target="blank">
          <div>
            <img  class="logo" src="assets/images/Walkzero-1 6.svg" alt="">
            <img  class="icon" src="assets/images/logo.svg" alt="" >
        </div>
        </a> -->
      <!-- </div> -->
      <!--  -->
      <div class="collapse navbar-collapse" [ngbCollapse]="isNavbarCollapsed">
        <div class="header-tab-wrapper">
          <div class="header-tab" [ngStyle]="{'width' : tabWidth}">
            <div class="header-quick-action-tab">
              <!-- <nav mat-tab-nav-bar [disableRipple]="true">
                <a mat-tab-link *ngFor="let tab of tabs; let i = index" 
                    (click)="selectTab(i)"
                    [active]="currentTab===i"
                    [class.current]="currentTab===i"
                    [class.prev]="currentTab>0 && i===(currentTab-1)"
                    [class.next]="i===(currentTab+1)"
                    (mouseenter)="currentHoverTab=i"
                    [class.current-focused]="currentHoverTab===i"
                    [class.prev-focused]="currentHoverTab>0 && i===(currentHoverTab-1)"
                    [class.next-focused]="i===(currentHoverTab+1)"
                    (mouseleave)="currentHoverTab=-1"
                    (contextmenu)="$event.stopPropagation(); onRightClick($event, i, rightClickMenu)">
                    <i class="fas {{tab.icon}}" *ngIf="tab.iconType==='fa'"></i>
                    <i class="material-icons" *ngIf="tab.iconType==='material'">{{tab.icon}}</i>
                    <span class="header-tab-title">{{tab.title}}</span> 
                    <i class="fas fa-times header-tab-close" (click)="removeTab(i)"></i>
                 </a>
              </nav> -->
            </div>
  
            <!-- <div ngbDropdown #rightClickMenu="ngbDropdown" class="close-tab-header">
              <div ngbDropdownMenu class="notification-dropdown pullDown"
                [style.left.px]="rightClickMenuPosition.x"
                [style.top.px]="rightClickMenuPosition.y"
                (mouseleave)="$event.stopPropagation(); rightClickMenu.close();">
                <div class="noti-list">
                  <ul class="menu">
                    <li class="body">
                      <ul class="user_dw_menu">
                        <li>
                          <a href="javascript:void(0)" (click)="removeTab(currentTab)">
                            <span class="add-li p-0">Close</span>
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)" (click)="closeAllTabs()">
                            <span class="add-li p-0">Close all tabs</span>
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)" (click)="closeOthers()">
                            <span class="add-li p-0">Close other tabs</span>
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)" (click)="closeRight()" ngbDropdownItem [disabled]="rightClickMenuIndex===(allTabs.length-1)">
                            <span class="add-li p-0">Close all to the right</span>
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)" (click)="closeLeft()" ngbDropdownItem [disabled]="rightClickMenuIndex===0">
                            <span class="add-li p-0">Close all to the left</span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div> -->
            
            <!-- <div class="add-tab-wrapper" [class.inactive-last]="currentTab<tabs.length-1" ngbDropdown #addDrop="ngbDropdown" (mouseenter)="$event.stopPropagation(); addDrop.open();">
              <button class="add-tab nav-notification-icons" (click)="addTab('New Employee', employeeTemplate, 'fa-user-alt', 'fa')" ngbDropdownToggle><img src="assets\images\icons\add-tab.svg"></button>
              <div ngbDropdownMenu class="header-tab-dropdown pullDown" (mouseleave)="$event.stopPropagation(); addDrop.close();">
                <div class="noti-list">
                  <ul class="menu">
                    <li class="body">
                      <ul class="user_dw_menu">
                        <li class="header">
                          <ng-container>
                            <span class="font-weight-5">Quick Actions</span>
                          </ng-container>
                        </li>
                        <li>
                          <a href="javascript:void(0)" (click)="addTab('New Employee', employeeTemplate, 'fa-user-alt', 'fa')">
                            <i class="fas fa-user-alt"></i>
                            <span class="add-li p-0">Employee</span>
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)" (click)="addTab('New Group', groupTemplate, 'fa-user-friends', 'fa')">
                            <i class="fas fa-user-friends"></i>
                            <span class="add-li p-0">Group</span>
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)" (click)="addTab('New Vendor', vendorTemplate, 'fa-user-tag', 'fa')">
                              <i class="fas fa-user-tag"></i>
                              <span class="add-li p-0">Vendor</span>
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)" (click)="addTab('Client', clientTemplate, 'fa-user-tie', 'fa')">
                            <i class="fas fa-user-tie"></i>
                            <span class="add-li p-0">Client</span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div> -->
           
            <!-- <div class="add-tab-wrapper" ngbDropdown #moreDrop="ngbDropdown" [hidden]="moreTabs.length===0">
              <button class="add-tab nav-notification-icons" ngbDropdownToggle>More<i class="fa fa-angle-down mx-2"></i></button>
              <div ngbDropdownMenu class="header-tab-dropdown pullDown more" (mouseleave)="$event.stopPropagation(); moreDrop.close();">
                <div class="noti-list">
                  <ul class="menu mb-0">
                    <li class="body">
                      <ul class="user_dw_menu">
                        <li class="header">
                          <ng-container>
                            <span class="font-weight-5">Actions ({{moreTabs.length}})</span>
                          </ng-container>
                        </li>
                        <div class="inner-wrapper">
                          <li class="" *ngFor="let tab of moreTabs; let i=index; trackBy: trackByIndex">
                            <a href="javascript:void(0)" (click)="selectMoreTab(i)">
                              <i class="fas {{tab.icon}}" *ngIf="tab.iconType==='fa'"></i>
                              <i class="material-icons" *ngIf="tab.iconType==='material'">{{tab.icon}}</i>
                              <span class="p-0">{{tab.title}}</span>
                              <span class="fas fa-times close float-right" (click)="removeMoreTab(i)"></span>
                            </a>
                          </li>
                        </div>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>      
            </div> -->
          </div>
  
          <ul class="nav navbar-nav navbar-right">
            <!-- Full Screen Button -->
            <li class="fullscreen">
              <button mat-icon-button (click)="callFullscreen()" class="nav-right-icons">
                <img class="icon-15" src="assets\images\icons\fullscreen.svg">
              </button>
            </li>
            <!-- #END# Full Screen Button -->
  
            
            <!-- #START# Notifications-->
            <li class="nav-item" ngbDropdown>
              <button mat-icon-button ngbDropdownToggle class="nav-right-icons">
                <img class="icon-15" src="assets\images\icons\header-notification.svg">
              </button>
              <div ngbDropdownMenu class="notification-dropdown notification pullDown" >
                <div class="noti-list dropdown-header-wrapper">
                  <ul class="menu">
                    <li>
                      <a href="javascript:void(0)" *ngFor="let notification of notifications; trackBy: trackByItem" onClick="return false;">
                        <span class="table-img msg-user">
                          <img src="assets/images/logo-icon.svg" alt="">
                        </span>
                        <span class="menu-info">
                          <span class="menu-title">{{notification.userName}}</span>
                          <span class="menu-desc">
                            <i class="material-icons">access_time</i> {{notification.time}}
                          </span>
                          <span class="menu-desc">{{notification.message}}</span>
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
                <a class="text-center d-block border-top py-1">Read
                  All Notifications</a>
              </div>
            </li>
            <!-- #END# Notifications-->
  
            <!-- #START# Profile -->
            <li class="nav-item user_profile" ngbDropdown>
              <a
                href="javascript:void(0)"
                onClick="return false;"
                ngbDropdownToggle
                role="button"
                class="nav-notification-icons pt-0"
                [attr.aria-label]="'Account menu for ' + (displayName || 'User')"
                aria-haspopup="true">
                <ng-container *ngIf="employee_details?.profile_url; else userHdrBadge">
                  <wz-shimmer-data [isDataLoading]="is_employee_info_loading" [shimmerClass]="'h-px-30 w-px-30 rounded-50'">
                    <span class="table-img msg-user">
                      <img [src]="employee_details.profile_url" class="rounded-circle" width="32" height="32" alt="User">
                    </span>
                  </wz-shimmer-data>
                </ng-container>
                <ng-template #userHdrBadge>
                  <span class="profile-avatar profile-avatar--sm">{{ avatarInitial }}</span>
                </ng-template>
              </a>
              <div
                ngbDropdownMenu
                class="profile-dropdown dropdown-menu"
                role="menu"
                aria-label="User profile menu">
                <div class="profile-dropdown__header">
                  <ng-container *ngIf="user?.photo; else profileDropdownAvatar">
                    <img
                      class="profile-avatar profile-avatar--lg profile-avatar--image"
                      [src]="user?.photo"
                      [alt]="displayName || 'User'">
                  </ng-container>
                  <ng-template #profileDropdownAvatar>
                    <div class="profile-avatar profile-avatar--lg" aria-hidden="true">{{ avatarInitial }}</div>
                  </ng-template>
                  <p class="profile-dropdown__name">{{ displayName || 'User' }}</p>
                  <span class="profile-dropdown__role" *ngIf="roleLabel">{{ roleLabel }}</span>
                  <p class="profile-dropdown__email" *ngIf="userEmail">{{ userEmail }}</p>
                </div>

                <div class="profile-dropdown__divider" role="separator"></div>

                <ul class="profile-dropdown__menu" role="none">
                  <li role="none">
                    <a class="profile-dropdown__item" [href]="profileUrl" role="menuitem">
                      <mat-icon aria-hidden="true">person_outline</mat-icon>
                      <span>Profile</span>
                    </a>
                  </li>
                  <li role="none">
                    <a class="profile-dropdown__item" href="javascript:void(0)" role="menuitem">
                      <mat-icon aria-hidden="true">chat_bubble_outline</mat-icon>
                      <span>Feedback</span>
                    </a>
                  </li>
                  <li role="none">
                    <a class="profile-dropdown__item" href="javascript:void(0)" role="menuitem">
                      <mat-icon aria-hidden="true">help_outline</mat-icon>
                      <span>Help</span>
                    </a>
                  </li>
                </ul>

                <div class="profile-dropdown__divider" role="separator"></div>

                <ul class="profile-dropdown__menu profile-dropdown__menu--footer" role="none">
                  <li role="none">
                    <a
                      class="profile-dropdown__item profile-dropdown__item--logout"
                      href="javascript:void(0)"
                      role="menuitem"
                      (click)="logout()">
                      <mat-icon aria-hidden="true">logout</mat-icon>
                      <span>Logout</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <!-- #END# Profile -->
          </ul>
        </div>
      </div>
    </div>
  </nav>